import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

function Availability() {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleSearch = () => {
  if (startDate && endDate) {
    //const checkin = startDate.toISOString().split('T')[0];
    //const checkout = endDate.toISOString().split('T')[0];
    //console.log('Check-in:', checkin, ' Check-out:', checkout);
    //const encodedURL = `https://www.booking.com/Share-T8MFzr?checkin=${checkin}&checkout=${checkout}`;
      const pad = (n) => String(n).padStart(2, '0');

      const ciY = startDate.getFullYear();
      const ciM = pad(startDate.getMonth() + 1);
      const ciD = pad(startDate.getDate());

      const coY = endDate.getFullYear();
      const coM = pad(endDate.getMonth() + 1);
      const coD = pad(endDate.getDate());

      console.log('Check-in:', `${ciY}-${ciM}-${ciD}`, ' Check-out:', `${coY}-${coM}-${coD}`);
    const propertyPath = 'Share-T8MFzr';
    
    const encodedURL = `https://www.booking.com/${propertyPath}?checkin_year=${ciY}&checkin_month=${ciM}&checkin_monthday=${ciD}&checkout_year=${coY}&checkout_month=${coM}&checkout_monthday=${coD}`;
    window.open(encodedURL, '_blank');
  }
};


  return (
    <div className="p-10 max-w-xl mx-auto text-center">
      <h1 className="text-3xl font-bold text-blue-800 mb-2">Check Availability</h1>

      <p className="text-gray-600 mb-1">
        📍 Located in Cidade Velha, Santiago Island, Cape Verde
      </p>

      <a
        href="https://www.google.com/maps/search/?api=1&query=Cidade+Serena+Guesthouse,+Cidade+Velha,+Cape+Verde"
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-700 underline text-sm mb-6 block"
      >
        View on Google Maps
      </a>

      <p className="text-gray-700 mb-6">
        Select your preferred dates to check room availability.
      </p>

      <div className="flex flex-col md:flex-row justify-center gap-4 mb-6">
        <DatePicker
          selected={startDate}
          onChange={(date) => setStartDate(date)}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          placeholderText="Check-in"
          className="p-2 border rounded w-full"
        />
        <DatePicker
          selected={endDate}
          onChange={(date) => setEndDate(date)}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          minDate={startDate}
          placeholderText="Check-out"
          className="p-2 border rounded w-full"
        />
      </div>

      <button
        onClick={handleSearch}
        disabled={!startDate || !endDate}
        className="bg-blue-700 text-white px-6 py-2 rounded hover:bg-blue-800 disabled:opacity-50"
      >
        Check on Booking.com
      </button>

      <p className="mt-4 text-sm text-gray-500">
        This will open Booking.com in a new tab with your selected dates.
      </p>
    </div>
  );
}

export default Availability;
